import React, { Fragment } from 'react';
import { translate } from '../Services/translation';

const FilterTags = (({facetFilters, searchFacetChange, navigationTheme}) => {
    const selectedFacetGroup = facetFilters.filter(filter => filter.selectedOptions.length>0);
    const selectedFacetOption = selectedFacetGroup.reduce((accumulator, group) => {
        if (!group) {
            return accumulator;
        }
        const {options, selectedOptions} = group;
        const groupOptions = options.filter(option => selectedOptions.includes(option.id)).map(option=>({...option, group}));
        return [
            ...accumulator,
            ...groupOptions
        ];
    }, []);
    return ( selectedFacetGroup.length === 0 ? null :
        <div>
        </div>
)})

export default FilterTags;